import { queryKeys } from '@sshop/api-client';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';

export const shippingOptionsQuery = () =>
  defineQuery({
    queryKey: queryKeys.checkout.shippingOptions(),
    queryFn: ({ signal }) => api.orders.listShippingOptions(signal),
    staleTime: 0,
  });
